import { IconName } from '@ardoq/icons';
import { type I18nLocale, t } from '@ardoq/i18n';
import { isPresentationMode } from 'env';
import {
  ZoomControls,
  ZoomControl,
} from 'atomicComponents/Zoomable/ZoomControls';
import { ZoomContainer } from 'tabview/relationshipDiagrams/atoms';
import { RelationshipsViewSettings } from '../types';
import { notifyHighlightDisconnectedComponentsChanged } from '../sharedControlsConfigs';
import { DisabledZoomControls } from '@ardoq/view-settings';

type RelationshipsViewZoomControlsProperties = {
  viewSettings: RelationshipsViewSettings;
  zoomIn: VoidFunction;
  zoomOut: VoidFunction;
  onZoomFit: VoidFunction;
  onOptimizeLayout: VoidFunction;
  isOptimizeLayoutDisabled: boolean;
  disabledState: DisabledZoomControls;
  i18nLocale: I18nLocale;
};
const RelationshipsViewZoomControls = ({
  viewSettings,
  zoomIn,
  zoomOut,
  onZoomFit,
  onOptimizeLayout,
  isOptimizeLayoutDisabled,
  disabledState,
  i18nLocale,
}: RelationshipsViewZoomControlsProperties) => {
  const { highlightDisconnectedComponents } = viewSettings;
  return (
    <ZoomContainer>
      {isPresentationMode() && (
        <ZoomControl
          label={t(
            i18nLocale,
            'relationsD3View:settingsBar.highlightDisconnected',
            'Highlight disconnected components'
          )}
          iconName={IconName.BULLSEYE}
          isActive={highlightDisconnectedComponents}
          onClick={() => {
            notifyHighlightDisconnectedComponentsChanged({
              highlightDisconnectedComponents,
              persistent: false,
            });
          }}
        />
      )}
      <ZoomControls
        zoomIn={zoomIn}
        zoomOut={zoomOut}
        zoomCenter={onZoomFit}
        disabledState={disabledState}
        i18nLocale={i18nLocale}
      />
      <ZoomControl
        label={t(
          i18nLocale,
          'relationsD3View:view.optimizeLayout',
          'Optimize layout'
        )}
        iconName={IconName.OPTIMIZE_LAYOUT}
        onClick={onOptimizeLayout}
        disabled={isOptimizeLayoutDisabled}
      />
    </ZoomContainer>
  );
};

export { RelationshipsViewZoomControls };
